import type { FunctionComponent } from 'react';
import { useToken } from '../../../Flow/ConsentContextProvider';
import McpSseBanner from '../McpSseBanner/McpSseBanner';

const McpBanners: FunctionComponent = () => {
  const token = useToken();
  if (token.serviceType !== 'MCP') return null;
  return <McpSseBanner />;
};

export default McpBanners;
